<template lang="pug">
  svg(viewBox="0 0 59 78", :class="{ dark, light }")
    path.file_cover(d="M0 78H58.9989V14L45 0H0V78Z")
    path.file_corner(d="M45 14L59 14L45 0V14Z")
</template>

<script>
export default {
  props: {
    // Тёмная цветовая гамма
    dark: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/variables';

  svg {
    .file_cover { transition: all .3s $easing; }

    &.dark {
      .file_cover { fill: $white; }

      .file_corner {
        fill: $sub-black;
        fill-opacity: .15;
      }
    }

    &.light {
      .file_cover { fill: $light-theme-line; }

      .file_corner { fill: $light-theme-background; }
    }
  }
</style>
